import { UserProfile,RoleType } from '@dirootie-domain/iam';

import React, { createContext, useContext } from 'react';
import { AzureAdToken } from '../../packages/domain/iam/azure-ad.types';

export interface SessionState {
  userProfile: {id:string,email: string, role: RoleType,roleImpersonated:RoleType} | undefined;
  roleImpersonated: RoleType | undefined;
  isAuthenticated: boolean;
  setUserProfile: React.Dispatch<React.SetStateAction<UserProfile | undefined>>;
  setImpersonatedRole: React.Dispatch<React.SetStateAction<RoleType | undefined>>;
  handleLoginSuccess: (result: AzureAdToken) => void;
  getRouteBasedOnRole: () => string;
}

const defaultSessionState: SessionState = {
  isAuthenticated: true,
  userProfile: undefined,
  roleImpersonated: "STUDY_DIRECTOR",
  setUserProfile: () => {},
  setImpersonatedRole: () => {},
  handleLoginSuccess: (s:any) => {},
  getRouteBasedOnRole: () => "",
};

export const SessionContext = createContext<SessionState>(defaultSessionState);

export const useSession = () => useContext(SessionContext);

export const useUserContext = () => {
  const session = useSession();
  const context = {
    userRole: session.userProfile?.role,
    userId: session.userProfile?.id,
    role: session.roleImpersonated,
    setImpersonatedRole: session.setImpersonatedRole,
  }
  return context;
}
